/**
 * Тур по странице геозон.
 * Знакомит пользователя с созданием и управлением геозонами.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'geozones-page',
  name: 'help.tours.geozones.name',
  description: 'help.tours.geozones.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Карта с геозонами
    {
      element: '.map-container',
      titleKey: 'help.tours.geozones.map.title',
      descriptionKey: 'help.tours.geozones.map.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 2: Тулбар карты (включая инструменты рисования)
    {
      element: '.map-toolbar',
      titleKey: 'help.tours.geozones.mapToolbar.title',
      descriptionKey: 'help.tours.geozones.mapToolbar.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Панель геозон
    {
      element: '.side-panel--left',
      titleKey: 'help.tours.geozones.panel.title',
      descriptionKey: 'help.tours.geozones.panel.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 4: Поиск
    {
      element: '.geozone-panel__toolbar .search-bar',
      titleKey: 'help.tours.geozones.search.title',
      descriptionKey: 'help.tours.geozones.search.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 5: Фильтр по типам геозон
    {
      element: '.geozone-panel__dropdown',
      titleKey: 'help.tours.geozones.filter.title',
      descriptionKey: 'help.tours.geozones.filter.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 6: Фильтры видимости
    {
      element: '.geozone-panel__filters',
      titleKey: 'help.tours.geozones.visibility.title',
      descriptionKey: 'help.tours.geozones.visibility.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 7: Список геозон
    {
      element: '.geozone-feed',
      titleKey: 'help.tours.geozones.list.title',
      descriptionKey: 'help.tours.geozones.list.description',
      side: 'left',
      align: 'start',
    },
  ],
}
